import proj4 from 'proj4';

// Définir les projections (inchangé)
proj4.defs('EPSG:4326', '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees');
proj4.defs('EPSG:26191', '+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=-5.4 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356515 +towgs84=31,146,47,0,0,0,0 +units=m +no_defs');


const generateHandle = (counter) => {
  return (0x1A + counter).toString(16).toUpperCase();
};


const convertCoordinatesToMeters = (coordinates, geometryType) => {
  try {
    console.log(`🔁 Conversion ${geometryType}:`, coordinates);
    
    if (geometryType === 'Point') {
      const [lng, lat] = coordinates;
      const [x, y] = proj4('EPSG:4326', 'EPSG:26191', [lng, lat]);
      console.log(`📍 Point converti: [${lng}, ${lat}] -> [${x}, ${y}]`);
      return [x, y];
    }
    
    if (geometryType === 'LineString') {
      return coordinates.map(coord => {
        const [lng, lat] = coord;
        const [x, y] = proj4('EPSG:4326', 'EPSG:26191', [lng, lat]);
        return [x, y];
      });
    }
    
    if (geometryType === 'Polygon') {
      return coordinates.map(ring => 
        ring.map(coord => {
          const [lng, lat] = coord;
          const [x, y] = proj4('EPSG:4326', 'EPSG:26191', [lng, lat]);
          return [x, y];
        })
      );
    }
    
    if (geometryType === 'MultiPolygon') {
      return coordinates.map(polygon => 
        polygon.map(ring => 
          ring.map(coord => {
            const [lng, lat] = coord;
            const [x, y] = proj4('EPSG:4326', 'EPSG:26191', [lng, lat]);
            return [x, y];
          })
        )
      );
    }
    return coordinates;
  } catch (error) {
    console.error('❌ Erreur conversion coordonnées:', error);
    return coordinates;
  }
};


const getLayerForFeature = (feature, layers) => {
  const props = feature.properties || {};
  
  if (props.type === 'titre') return layers.titres;
  if (props.type === 'batiment') return layers.batiments;
  if (props.type === 'texte') return layers.textes;
  if (props.source === 'import') return layers.import;
  
  return layers.titres;
};


const calculatePolygonCenter = (coordinates) => {
  if (coordinates.length === 0) return [0, 0];
  
  let sumX = 0;
  let sumY = 0;
  
  coordinates.forEach(coord => {
    sumX += coord[0];
    sumY += coord[1];
  });
  
  return [sumX / coordinates.length, sumY / coordinates.length];
};

// ==================== PARTIE DXF CORRIGÉE ====================

// Version simplifiée du header DXF (format AutoCAD R12)
const generateCompleteDxfHeader = () => {
  return `0
SECTION
2
HEADER
9
$ACADVER
1
AC1009
9
$INSUNITS
70
6
0
ENDSEC
`;
};

// Section TABLES simplifiée
const generateDxfTablesSection = () => {
  return `0
SECTION
2
TABLES
0
TABLE
2
LTYPE
70
1
0
LTYPE
2
CONTINUOUS
70
0
3
Solid line
72
65
73
0
40
0.0
0
ENDTAB
0
TABLE
2
LAYER
70
4
0
LAYER
2
0
70
0
62
7
6
CONTINUOUS
0
LAYER
2
TITRES
70
0
62
1
6
CONTINUOUS
0
LAYER
2
BATIMENTS
70
0
62
3
6
CONTINUOUS
0
LAYER
2
TEXTES
70
0
62
5
6
CONTINUOUS
0
ENDTAB
0
TABLE
2
STYLE
70
1
0
STYLE
2
STANDARD
70
0
40
0.0
41
1.0
50
0.0
71
0
42
2.5
3
txt
4

0
ENDTAB
0
ENDSEC
`;
};

// Section BLOCKS simplifiée
const generateDxfBlocksSection = () => {
  return `0
SECTION
2
BLOCKS
0
BLOCK
8
0
2
$MODEL_SPACE
70
0
10
0.0
20
0.0
30
0.0
3
$MODEL_SPACE
1

0
ENDBLK
8
0
0
ENDSEC
`;
};

// Section ENTITIES corrigée - Utilisation de POLYLINE au lieu de LWPOLYLINE
const generateDxfEntitiesSection = (geoJSONData, layers) => {
  let entitiesContent = `0
SECTION
2
ENTITIES
`;
  
  let handleCounter = 0;
  
  geoJSONData.features.forEach((feature, index) => {
    console.log(`📝 Traitement feature ${index}:`, feature.geometry.type);
    
    // Convertir les coordonnées en mètres (EPSG:26191)
    const convertedCoordinates = convertCoordinatesToMeters(
      feature.geometry.coordinates, 
      feature.geometry.type
    );
    
    const layerName = getLayerForFeature(feature, layers);
    
    // Créer l'entité géométrique (sans handles complexes)
    const entityHandle = generateHandle(handleCounter++);
    const featureDxf = convertGeoJSONToDxfEntity(
      { 
        ...feature, 
        geometry: {
          ...feature.geometry,
          coordinates: convertedCoordinates
        }
      }, 
      layerName
    );
    
    if (featureDxf) {
      entitiesContent += featureDxf;
      
      // Ajouter un texte pour les polygones
      if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
        const textDxf = generateTextForFeature(feature, convertedCoordinates, index);
        if (textDxf) {
          entitiesContent += textDxf;
        }
      }
    }
  });
  
  entitiesContent += `0
ENDSEC
`;
  
  return entitiesContent;
};

// Convertir une entité GeoJSON en entité DXF (simplifié)
const convertGeoJSONToDxfEntity = (feature, layerName) => {
  const { geometry } = feature;
  let dxfContent = '';

  console.log(`🔄 Conversion ${geometry.type} pour layer ${layerName}`);

  switch (geometry.type) {
    case 'Point':
      const [x, y] = geometry.coordinates;
      dxfContent += `0
POINT
8
${layerName}
10
${x.toFixed(3)}
20
${y.toFixed(3)}
30
0.0
`;
      break;

    case 'LineString':
      if (geometry.coordinates.length >= 2) {
        dxfContent += `0
POLYLINE
8
${layerName}
66
1
70
0
`;
        
        geometry.coordinates.forEach(coord => {
          const [x, y] = coord;
          dxfContent += `0
VERTEX
8
${layerName}
10
${x.toFixed(3)}
20
${y.toFixed(3)}
30
0.0
70
0
`;
        });
        
        dxfContent += `0
SEQEND
8
${layerName}
`;
      }
      break;

    case 'Polygon':
      if (geometry.coordinates.length > 0 && geometry.coordinates[0].length > 0) {
        const exteriorRing = geometry.coordinates[0];
        
        if (exteriorRing.length >= 3) {
          dxfContent += `0
POLYLINE
8
${layerName}
66
1
70
1
`;
          
          exteriorRing.forEach(coord => {
            const [x, y] = coord;
            dxfContent += `0
VERTEX
8
${layerName}
10
${x.toFixed(3)}
20
${y.toFixed(3)}
30
0.0
70
0
`;
          });
          
          dxfContent += `0
SEQEND
8
${layerName}
`;
        }
      }
      break;

    case 'MultiPolygon':
      geometry.coordinates.forEach((polygon, polyIndex) => {
        if (polygon.length > 0 && polygon[0].length >= 3) {
          const exteriorRing = polygon[0];
          
          dxfContent += `0
POLYLINE
8
${layerName}
66
1
70
1
`;
          
          exteriorRing.forEach(coord => {
            const [x, y] = coord;
            dxfContent += `0
VERTEX
8
${layerName}
10
${x.toFixed(3)}
20
${y.toFixed(3)}
30
0.0
70
0
`;
          });
          
          dxfContent += `0
SEQEND
8
${layerName}
`;
        }
      });
      break;

    default:
      console.warn(`❌ Type de géométrie non supporté: ${geometry.type}`);
  }

  return dxfContent;
};

// Générer un texte pour une feature (simplifié)
const generateTextForFeature = (feature, coordinates, index) => {
  const { properties, geometry } = feature;
  let textContent = '';
  
  // Déterminer le texte à afficher
  let text = properties.nom || properties.numero || properties.titref || `Titre_${index + 1}`;
  
  // Déterminer la position du texte
  let x = 0, y = 0;
  
  if (geometry.type === 'Point') {
    [x, y] = coordinates;
    y += 10; // Décaler légèrement au-dessus du point
  } else if (geometry.type === 'Polygon' && coordinates[0] && coordinates[0].length > 0) {
    [x, y] = calculatePolygonCenter(coordinates[0]);
  } else if (geometry.type === 'LineString' && coordinates.length > 0) {
    const middleIndex = Math.floor(coordinates.length / 2);
    [x, y] = coordinates[middleIndex];
  }
  
  if (x !== 0 || y !== 0) {
    textContent = `0
TEXT
8
TEXTES
10
${x.toFixed(3)}
20
${y.toFixed(3)}
30
0.0
40
3.0
1
${text}
50
0.0
7
STANDARD
`;
  }
  
  return textContent;
};


const exportToDxf = (geoJSONData, fileName = 'export') => {
  console.log("🔄 Début exportation DXF corrigée...");
  
  try {
    // Définir les couches
    const layers = {
      titres: 'TITRES',
      batiments: 'BATIMENTS',
      textes: 'TEXTES',
      import: '0'
    };
    
    // Construire le contenu DXF simplifié
    let dxfContent = generateCompleteDxfHeader();
    dxfContent += generateDxfTablesSection();
    dxfContent += generateDxfBlocksSection();
    dxfContent += generateDxfEntitiesSection(geoJSONData, layers);
    dxfContent += `0
EOF
`;
    
    console.log("✅ Contenu DXF généré (format simplifié AC1009)");
    console.log("📏 Nombre de features:", geoJSONData.features.length);
    
    // Téléchargement
    downloadFile(dxfContent, `${fileName}.dxf`, 'application/dxf');
    
  } catch (error) {
    console.error("❌ Erreur lors de l'export DXF:", error);
    throw error;
  }
};

// Fonction de téléchargement (inchangée)
const downloadFile = (content, fileName, mimeType) => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Fonction pour collecter les données de la carte (inchangée)
const collectMapDataForExport = (titres, titresFromPolygonControl, importedLayers, drawedLayers, mapMarkers) => {
  const features = [];
  
  // 1. Ajouter les titres de RECHERCHE
  if (titres && titres.length > 0) {
    console.log("📋 Ajout des titres de recherche:", titres.length);
    titres.forEach((titre, index) => {
      try {
        const geometry = JSON.parse(titre.geom_geojson);
        features.push({
          type: 'Feature',
          geometry: geometry,
          properties: {
            type: 'titre_recherche',
            source: 'recherche',
            nom: titre.titref || titre.graphic_de || titre.num || `Titre_${index + 1}`,
            numero: titre.titref || `REF_${index + 1}`,
            titref: titre.titref,
            surf_adop: titre.surf_adop ? Number(titre.surf_adop).toFixed(2) : null,
            pa_nom: titre.pa_nom || 'Non défini'
          }
        });
      } catch (error) {
        console.error("❌ Erreur parsing GeoJSON titre:", error);
      }
    });
  }
  
  // 2. Ajouter les titres de DrawPolygonControl
  if (titresFromPolygonControl && titresFromPolygonControl.length > 0) {
    console.log("📋 Ajout des titres de polygone:", titresFromPolygonControl.length);
    titresFromPolygonControl.forEach((titre, index) => {
      try {
        const geometry = JSON.parse(titre.geom_geojson);
        features.push({
          type: 'Feature',
          geometry: geometry,
          properties: {
            type: 'titre_polygone',
            source: 'recherche_polygone',
            nom: titre.titref || titre.graphic_de || titre.num || `Titre_Poly_${index + 1}`,
            numero: titre.titref || `REF_POLY_${index + 1}`,
            titref: titre.titref,
            surf_adop: titre.surf_adop ? Number(titre.surf_adop).toFixed(2) : null,
            pa_nom: titre.pa_nom || 'Non défini'
          }
        });
      } catch (error) {
        console.error("❌ Erreur parsing GeoJSON titre polygone:", error);
      }
    });
  }
  

  if (drawedLayers && drawedLayers.length > 0) {
    drawedLayers.forEach(layer => {
      if (layer.data && layer.data.features) {
        features.push(...layer.data.features.map(feature => ({
          ...feature,
          properties: {
            ...feature.properties,
            type: 'titre_dessine',
            source: 'dessin'
          }
        })));
      }
    });
  }
  

  if (importedLayers && importedLayers.length > 0) {
    importedLayers.forEach(layer => {
      if (layer.data && layer.data.features) {
        features.push(...layer.data.features.map(feature => ({
          ...feature,
          properties: {
            ...feature.properties,
            type: layer.type || 'imported',
            source: 'import',
            layerName: layer.name
          }
        })));
      }
    });
  }
  
  if (mapMarkers && mapMarkers.length > 0) {
    mapMarkers.forEach(marker => {
      features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [marker.position.lng, marker.position.lat]
        },
        properties: {
          type: 'marqueur',
          nom: marker.nom || 'Marqueur',
          description: marker.description || ''
        }
      });
    });
  }

  console.log(`🎯 TOTAL données collectées pour export: ${features.length} features`);
  
  return {
    type: 'FeatureCollection',
    features: features
  };
};

export {
  exportToDxf,
  convertCoordinatesToMeters,
  getLayerForFeature,
  calculatePolygonCenter,
  downloadFile,
  collectMapDataForExport
};